import React from "react";

export default function Community() {
  return (
    <div>
      <div className="balanceBox">
        <div className="balanceBoxInner bg-light">
          <h2 className="balanceBoxTitle text-center text-dark">Community</h2>
        </div>
      </div>
    </div>
  );
}
